import * as $ from "jquery";
import { dateUtility } from "./DateUtility";

declare global {
    interface JQuery<TElement extends Node = HTMLElement> {
        setEpCalendar: (calendar: CalendarWithHolidays) => JQuery<TElement>;
    }
}

/*
    Apply easy project account's schedule settings to datepicker (disables weekends and holidays on calendar)

    Example :

    const calendar = {
        WorkingDays: [1, 2, 3, 4, 5],
        PublicHolidays : [ {Name : "Some holiday", Date : new Date() } ]
        IncludePublicHolidays: true,
    };

    $("#someinput").datepicker(..some options..).setEpCalendar(calendar);
 */

$.fn.setEpCalendar = function (calendar: CalendarWithHolidays) {
    calendar = calendar || ({} as CalendarWithHolidays);

    const isDayEnabled = function (date: Date) {
        if (date == null) {
            return true;
        }

        const isWeekend = dateUtility.isWeekEnd(date, calendar);

        if (!isWeekend) {
            if (calendar.IncludePublicHolidays && calendar.PublicHolidays) {
                for (const holiday of calendar.PublicHolidays) {
                    // some controllers send all properties in lower case
                    const holidayDate: Date = holiday.Date || (holiday as any).date;

                    if (dateUtility.compareDates(date, holidayDate) === 0) {
                        return [false, "", holiday.Name];
                    }
                }
            }

            if (!dateUtility.isAvailableDate(date, calendar)) {
                return [false, ""];
            }

            return [true, ""];
        }

        return [false, ""];
    };

    this.datepicker("option", "beforeShowDay", isDayEnabled);

    return this;
};
